import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type CancelChangesModalProps = {
  titleText: string;
  bodyText: string;
  show: boolean;
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => void;
};

export default function CancelChangesModal({
  show,
  titleText,
  bodyText,
  onClose,
  onCancel,
  onSubmit,
}: CancelChangesModalProps) {
  const submit = () => {
    onSubmit();
    onClose();
  };

  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onClose} backdrop="static">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <Modal.Header>
          <button type="button" className="icon-btn" onClick={onCancel}>
            <i className="icon fas fa-times fa-lg"></i>
          </button>
          <h3 className="modal-title">{titleText}</h3>
        </Modal.Header>

        <div className="modal-spacer"></div>

        <Modal.Body>{bodyText}</Modal.Body>

        <div className="modal-spacer"></div>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary alt"
            onClick={onCancel}
          >
            {t('common.button.cancel')}
          </button>
          <button className="btn btn-secondary" type="submit" onClick={onClose}>
            {t('common.button.closeWithoutSaving')}
          </button>
          <button className="btn btn-primary" type="submit">
            {t('common.button.save')}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
